export default function Logo() {
  return <h1>👍Trip App👜</h1>;
}
